import moment from 'moment';
export const TouristDocumentType = Object.freeze({
    RussianForeignPassport: 1,
    RussianPassport: 2,
    RussianBirthCertificate: 3,
    ForeignDocument: 4,
});
export var BookingCustomerType;
(function (BookingCustomerType) {
    BookingCustomerType[BookingCustomerType["Tourist"] = 0] = "Tourist";
    BookingCustomerType[BookingCustomerType["Individual"] = 1] = "Individual";
    BookingCustomerType[BookingCustomerType["SoleProprietor"] = 2] = "SoleProprietor";
    BookingCustomerType[BookingCustomerType["Company"] = 3] = "Company";
})(BookingCustomerType || (BookingCustomerType = {}));
export var Availabilities;
(function (Availabilities) {
    Availabilities[Availabilities["Ok"] = 0] = "Ok";
    Availabilities[Availabilities["OnRequest"] = 1] = "OnRequest";
    Availabilities[Availabilities["StopSale"] = 2] = "StopSale";
})(Availabilities || (Availabilities = {}));
export const isExcursionPickupPointAvailable = (point, date) => {
    const dateValue = moment(date);
    if (!point || !date || !dateValue.isValid())
        return false;
    const day = dateValue.isoWeekday().toFixed(0);
    return !point.weekDays || point.weekDays.includes(day);
};
